<div class="confirm-dialog"
     [mmTestId]="'CONFIRM_DIALOG.CONTAINER'">
    <mm-dialog-title>{{data?.title}}</mm-dialog-title>

    <mm-dialog-content>{{data?.message}}</mm-dialog-content>

    <mm-dialog-footer>
        <button mm-button
                [color]="data?.cancel?.color || 'ghost'"
                [mmDialogClose]="false"
                [mmTestTarget]="'dialog-cancel-btn'">
            {{ data?.cancel?.label || ('PAGES.ACCOUNT.ORDERS_HISTORY.CANCEL_ORDER_LINE_DIALOG.CANCEL_BUTTON' | translate) }}
        </button>

        <button mm-button
                [color]="data?.submit?.color || 'warning'"
                [mmDialogClose]="true"
                [mmTestTarget]="'dialog-submit-btn'">
            {{ data?.submit?.label || ('PAGES.ACCOUNT.ORDERS_HISTORY.CANCEL_ORDER_LINE_DIALOG.CONFIRM_BUTTON' | translate) }}
        </button>
    </mm-dialog-footer>
</div>
